import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChild } from '@angular/core';
import { Splitter } from 'primeng/splitter';

import { injectSidebarContext } from '../sidebar-context';
import { SidebarExpandedDirective, SidebarIconDirective } from '../sidebar-slot.directive';

@Component({
    selector: 'adv-sidebar-header',
    templateUrl: './sidebar-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, Splitter],
    host: { class: 'block shrink-0' },
})
export class SidebarHeaderComponent {
    private readonly _sidebar = injectSidebarContext();

    protected readonly expandedContent = contentChild.required(SidebarExpandedDirective);
    protected readonly iconContent = contentChild.required(SidebarIconDirective);
    protected readonly iconOnly = this._sidebar.iconOnly;
}
